import React from "react"

const BlurComponentWrapper = ({
  opacity = 10,
  blur = 0,
  color = "white",
  onClick = () => {},
  children,
  disabled = false,
  className = "",
}) => {
  const isInteractive = !!onClick && !disabled

  return (
    <div
      className={`bg-${color}/${opacity} backdrop-blur-${blur} ${className}`}
      onClick={isInteractive ? onClick : undefined}
    >
      {children}
    </div>
  )
}

export default BlurComponentWrapper
